import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Heart, Sparkles, Gift, Star, Home, ShoppingBag } from 'lucide-react';
export function PersonalizedProducts() {
  const benefits = [{
    icon: <Star className="w-6 h-6" data-id="element-1771" />,
    title: 'Unique Creations',
    description: 'Stand out from the crowd with products that reflect your personality and taste'
  }, {
    icon: <Gift className="w-6 h-6" data-id="element-1772" />,
    title: 'Thoughtful Gifts',
    description: 'Give a gift that shows you care—personalization turns any item into a cherished keepsake'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-1773" />,
    title: 'Endless Possibilities',
    description: 'From home décor to fashion accessories, the options for personalization are limitless'
  }];
  const offerings = [{
    icon: '👕',
    title: 'Custom Apparel',
    description: 'T-shirts, hoodies, and hats that showcase your individuality',
    examples: ['Personalized t-shirts', 'Custom hoodies', 'Monogrammed hats', 'Family reunion shirts']
  }, {
    icon: '🏠',
    title: 'Home Goods',
    description: 'Towels, blankets, and décor pieces that add a personal touch to your space',
    examples: ['Embroidered towels', 'Custom blankets', 'Personalized pillows', 'Monogrammed robes']
  }, {
    icon: '🎒',
    title: 'Accessories',
    description: 'Bags, mugs, and everyday items transformed into one-of-a-kind treasures',
    examples: ['Custom tote bags', 'Personalized mugs', 'Monogrammed wallets', 'Engraved keychains']
  }];
  const occasions = [{
    icon: '🎂',
    name: 'Birthdays'
  }, {
    icon: '💍',
    name: 'Weddings'
  }, {
    icon: '👶',
    name: 'Baby Showers'
  }, {
    icon: '🎓',
    name: 'Graduations'
  }, {
    icon: '🎄',
    name: 'Holidays'
  }, {
    icon: '💝',
    name: 'Anniversaries'
  }];
  return <div className="flex flex-col w-full" data-id="element-1774">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1775">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1776">
          <div className="flex justify-center mb-6" data-id="element-1777">
            <Heart className="w-16 h-16 text-white" data-id="element-1778" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1779">
            Personalized Products
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1780">
            Crafted just for you! Transform ordinary items into extraordinary
            treasures with personalization that makes your heart sing.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1781">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1782">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-1783">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1784">
              Make It Yours!
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-1785">
              <p data-id="element-1786">
                At Wear Haus Designs, we believe that personalization is the
                magic touch that transforms an ordinary item into something
                extraordinary! Whether you're celebrating a special occasion,
                expressing your unique style, or creating the perfect gift, our
                personalized products add that special flair that makes your
                heart sing.
              </p>
              <p data-id="element-1787">
                From custom apparel and home goods to everyday accessories, we
                bring your vision to life with our in-house printing,
                embroidery, and laser etching services. Every personalized
                product is crafted with care, attention to detail, and a
                commitment to quality that ensures your one-of-a-kind creation
                is something you'll treasure for years to come.
              </p>
            </div>
          </div>

          {/* Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1788">
            {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100 text-center" data-id="element-1789">
                <div className="w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white mx-auto mb-4" data-id="element-1790">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1791">
                  {benefit.title}
                </h3>
                <p className="text-gray-600" data-id="element-1792">{benefit.description}</p>
              </div>)}
          </div>

          {/* Product Offerings */}
          <div className="mb-16" data-id="element-1793">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1794">
              Our Personalized Product Offerings
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1795">
              {offerings.map((offering, index) => <div key={index} className="bg-white rounded-xl p-8 border-2 border-gray-100 hover:border-wh-teal transition-colors" data-id="element-1796">
                  <div className="text-5xl mb-4" data-id="element-1797">{offering.icon}</div>
                  <h3 className="text-2xl font-bold text-wh-teal mb-3" data-id="element-1798">
                    {offering.title}
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-1799">{offering.description}</p>
                  <ul className="space-y-2" data-id="element-1800">
                    {offering.examples.map((example, exIndex) => <li key={exIndex} className="text-sm text-gray-600 flex items-center gap-2" data-id="element-1801">
                        <span className="w-1.5 h-1.5 bg-wh-pink rounded-full" data-id="element-1802"></span>
                        {example}
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>

          {/* Perfect For Section */}
          <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-2xl p-12 text-white mb-16" data-id="element-1803">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-1804">
              Perfect for Every Occasion
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-4xl mx-auto" data-id="element-1805">
              {occasions.map((occasion, index) => <div key={index} className="text-center" data-id="element-1806">
                  <div className="text-5xl mb-3" data-id="element-1807">{occasion.icon}</div>
                  <p className="text-sm font-medium" data-id="element-1808">{occasion.name}</p>
                </div>)}
            </div>
          </div>

          {/* Personalization Methods */}
          <div className="mb-16" data-id="element-1809">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-1810">
              How We Personalize
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1811">
              <div className="bg-gradient-to-br from-wh-pink to-pink-600 rounded-xl p-6 text-white text-center" data-id="element-1812">
                <div className="text-3xl mb-3" data-id="element-1813">🎨</div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1814">Embroidery</h3>
                <p className="text-sm text-white/90" data-id="element-1815">
                  Classic, elegant thread work
                </p>
              </div>
              <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-xl p-6 text-white text-center" data-id="element-1816">
                <div className="text-3xl mb-3" data-id="element-1817">🖨️</div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1818">Printing</h3>
                <p className="text-sm text-white/90" data-id="element-1819">
                  Vibrant, full-color designs
                </p>
              </div>
              <div className="bg-gradient-to-br from-wh-yellow to-yellow-500 rounded-xl p-6 text-gray-900 text-center" data-id="element-1820">
                <div className="text-3xl mb-3" data-id="element-1821">⚡</div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1822">Laser Etching</h3>
                <p className="text-sm text-gray-800" data-id="element-1823">
                  Precise, permanent marks
                </p>
              </div>
              <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white text-center" data-id="element-1824">
                <div className="text-3xl mb-3" data-id="element-1825">🔥</div>
                <h3 className="text-lg font-bold mb-2" data-id="element-1826">Heat Transfer</h3>
                <p className="text-sm text-white/90" data-id="element-1827">
                  Durable, detailed graphics
                </p>
              </div>
            </div>
          </div>

          {/* CTA Box */}
          <div className="bg-gradient-to-br from-wh-pink to-pink-600 rounded-2xl p-12 text-center text-white" data-id="element-1828">
            <Heart className="w-16 h-16 mx-auto mb-6" data-id="element-1829" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1830">
              Let's Get Personal!
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1831">
              Ready to create something truly special? Our talented team is here
              to help you bring your vision to life, all in-house! Contact us
              today to start designing personalized products that celebrate you
              or your loved ones.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1832">
              <a href="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-white text-wh-pink font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1833">
                Get Started
              </a>
              <a href="/services" className="inline-flex items-center justify-center px-8 py-4 bg-wh-yellow text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-colors" data-id="element-1834">
                View All Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1835" />
    </div>;
}